module.exports = __webpack_public_path__ + "img/Wallet.d494a883.gif";